import { call, fetchAllPages } from '../../shared/api.ts'
import type { apiDto } from '@rs/contracts'
/** ══ CỬA GỌI REST QUẢN LÝ NGƯỜI DÙNG (D06) ═══════════════════════════════════════════════════ */

/**
 * ⚠ KIỂU LẤY TỪ HỢP ĐỒNG, KHÔNG CHÉP TAY (KIEN-TRUC §12.3). Trước đợt N1, mỗi hình dạng dưới đây
 *   là một `interface` viết tay ở đây, song song với một `interface` khác bên `packages/modules`.
 *   Không có gì buộc hai bản khớp: đổi tên một trường ở máy chủ thì `tsc` vẫn xanh và màn hình
 *   lặng lẽ hiện `undefined`. Nay chỉ còn MỘT bản, ở `@rs/contracts`.
 */
export type AppUserRow = apiDto.AppUserDto


const B = '/api/v1/catalog/users'

export const fetchAppUsers = (): Promise<AppUserRow[]> => fetchAllPages<AppUserRow>(B)

export const createAppUserApi = (body: Record<string, unknown>): Promise<AppUserRow> =>
  call<AppUserRow>(B, { method: 'POST', body: JSON.stringify(body) })

export const updateAppUserApi = (
  id: string, version: number, patch: Record<string, unknown>,
): Promise<void> =>
  call<void>(`${B}/${id}`, { method: 'PATCH', body: JSON.stringify({ ...patch, version }) })

/**
 * Xoá hồ sơ nhân sự — XOÁ MỀM ở máy chủ (đóng dấu `deleted_at`, xem `@rs/identity.deleteAppUser`).
 * Bằng `POST …/delete` kèm `version` chứ không phải `DELETE`: cửa `DELETE` không mang thân request
 * được, mà không có `version` thì hai người cùng sửa một hồ sơ sẽ không lộ ra.
 */
export const deleteAppUserApi = (id: string, version: number): Promise<void> =>
  call<void>(`${B}/${id}/delete`, { method: 'POST', body: JSON.stringify({ version }) })
